import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'
import Link from 'next/link';



// Component
function Roadmap(props: any) {
    const theme = useTheme();
    const isHorizontalMode = useMediaQuery(theme.breakpoints.up(1270));
    const { t, i18n } = useTranslation();

    let roadmapDetails: any = t("home.roadmapDetails", { returnObjects: true });

    //
    return (
        <Box className={props.className} >
            <Typography className="home-roadmap-header">
                {t("home.roadmapHeader")}
            </Typography>

            <Box className="home-roadmap-text">
                {t("home.roadmapText")}
            </Box>

            <Box className="home-roadmap-roadmap-cont">
                <Box className="home-roadmap-roadmap-item" style={{ background: "", flexGrow: "1" }}>

                    <Box className="home-roadmap-roadmap-item-header-container" >
                        <Box className="home-roadmap-roadmap-item-header">{roadmapDetails[0].header}</Box>
                        {isHorizontalMode && <Box sx={{ background: "white", height: "2px", flexGrow: "1", margin: "0px 20px 0px 30px" }}></Box>}
                    </Box>

                    <Box className="home-roadmap-roadmap-item-items">
                        {
                            roadmapDetails[0].list.map((el: any) => {
                                return (<Box key={el} className="home-roadmap-roadmap-item-text">- {el}</Box>)
                            })
                        }
                    </Box>
                </Box>

                {/* vertical line for small screens */}
                {!isHorizontalMode && <Box sx={{ height: "70px", width: "2px", background: "white", margin: "10px 0px 10px 0px" }}></Box>}

                <Box className="home-roadmap-roadmap-item" style={{ background: "", flexGrow: "1" }}>
                    <Box className="home-roadmap-roadmap-item-header-container" >
                        <Box className="home-roadmap-roadmap-item-header">{roadmapDetails[1].header}</Box>
                        {isHorizontalMode && <Box sx={{ background: "white", height: "2px", flexGrow: "1", margin: "0px 20px 0px 30px" }}></Box>}
                    </Box>

                    <Box className="home-roadmap-roadmap-item-items">
                        {
                            roadmapDetails[1].list.map((el: any) => {
                                return (<Box key={el} className="home-roadmap-roadmap-item-text">- {el}</Box>)
                            })
                        }
                    </Box>
                </Box>

                {/* vertical line for small screens */}
                {!isHorizontalMode && <Box sx={{ height: "70px", width: "2px", background: "white", margin: "10px 0px 10px 0px" }}></Box>}

                <Box className="home-roadmap-roadmap-item" style={{ background: "" }}>
                    <Box className="home-roadmap-roadmap-item-header">{roadmapDetails[2].header}</Box>

                    <Box className="home-roadmap-roadmap-item-items">
                        {
                            roadmapDetails[2].list.map((el: any) => {
                                return (<Box key={el} className="home-roadmap-roadmap-item-text">- {el}</Box>)
                            })
                        }
                    </Box>
                </Box>
            </Box>

            {/*<Box className="home-roadmap-link">
               <Link href="/whitepaper">{t("home.roadmapFullRoadmap")}</Link>
            </Box>*/}
        </Box>

    );
}

// Default style!
const RoadmapStyled = styled(Roadmap)({
    height: "auto",
    padding: "30px 40px 30px 40px",
    textAlign: "center",
    margin: "0px",
    backgroundImage: "url(blurred_bg.jpg)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    ".home-roadmap-header": {
        color: "white",
        fontWeight: "700",
        fontSize: "40px"
    },
    ".home-roadmap-text": {
        color: "white",
        display: "inline-block",
        maxWidth: "500px"
    },
    ".home-roadmap-roadmap-cont": {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        padding: "30px 15px 15px 15px",
    },
    ".home-roadmap-roadmap-item": {
        padding: "5px 5px 5px 5px",
        display: "inline-block",
        //width: "400px",
        textAlign: "left"
    },
    ".home-roadmap-roadmap-item-header-container": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    ".home-roadmap-roadmap-item-header": {
        color: "white",
        fontWeight: "700",
        fontSize: "30px"
    },
    ".home-roadmap-roadmap-item-items": {
        fontSize: "14px",
        color: "white",
        fontWeight: 700,
        textTransform: "uppercase"
    },
    ".home-roadmap-roadmap-item-text": {
        padding: "4px 0px 4px 0px"
    },
    ".home-roadmap-link": {
        color: "white",
        textDecoration: "underline",
        fontSize: "15px",
        marginTop: "50px",
        cursor: "pointer",
        fontWeight: 700,
        "&:hover": {
            color: "#e5e5e5"
        }
    },
    ['@media (max-width:1270px)']: {
        ".home-roadmap-roadmap-cont": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            flexDirection: "column",
            padding: "30px 15px 15px 15px",
        },
        ".home-roadmap-roadmap-item": {
            padding: "5px 5px 5px 5px",
            display: "inline-block",
            flexGrow: 1,
            textAlign: "left",
            flexShrink: 1
        },
        ".home-roadmap-roadmap-item-header-container": {
            display: "flex",
            justifyContent: "start",
            alignItems: "center"
        },
    }
});

// Export
export default RoadmapStyled;
